// skills/smithing/index.js
// Smithing skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderSmithingUI,
    updateSmithingUI,
    initSmithingUI,
    toggleSmithing,
    toggleSmithingArrowheads,
    toggleSmithingSword,
    toggleSmithingDirk,
    toggleSmithingGreatsword,
    toggleSmithingMeleeArmor,
    toggleSmithingBulwark,
    upgradeTool,
    switchTab,
    switchMeleeTier
} from './smithingUI.js';

/**
 * Smithing skill configuration
 */
const smithingConfig = {
    id: 'smithing',
    name: 'Smithing',
    icon: '🔨',
    iconImage: 'assets/icons/skill_icons/smithing.png',
    description: 'Smelt ores into bars and forge melee equipment',

    tabs: [
        { id: 'bars', name: 'Bars', default: true },
        { id: 'ammunition', name: 'Arrowheads' },
        { id: 'melee', name: 'Equipment' }  // Tier tabs rendered dynamically
    ],

    render(params = {}) {
        renderSmithingUI(params);
    },

    update() {
        updateSmithingUI();
    },

    init() {
        initSmithingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('smithing', smithingConfig);

if (typeof window !== 'undefined') {
    window.smithingUI = {
        toggleSmithing,
        toggleSmithingArrowheads,
        toggleSmithingSword,
        toggleSmithingDirk,
        toggleSmithingGreatsword,
        toggleSmithingMeleeArmor,
        toggleSmithingBulwark,
        upgradeTool,
        switchTab,
        switchMeleeTier
    };
}

export default smithingConfig;
